import { render } from "./UploadIcon.vue?vue&type=template&id=143b7c6b"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__